export const NUM_CURATED_TRAILS = 450; // thousand
export const NUM_USERS = 75; // million
export const LOGGED_DISTANCE = 2092147200000; // meters
